import { Helmet } from "react-helmet-async";

const SITE = "AIR.POG";
const DEFAULT_DESC = "AIR.POG — JUST POG IT 🎯 We're POGs (People on the Go). The map finds your next POG (Point of Guidance) for live local deals — and scoring one is the ultimate POG (Play of the Game).";
const DEFAULT_IMG = "https://airpog.com/og-image-v2.png";

export const PageMeta = ({ title, description = DEFAULT_DESC, path = "", image = DEFAULT_IMG }) => {
  const full = title ? `${title} · ${SITE}` : `${SITE} — The deals come to you`;
  const url = `https://airpog.com${path}`;
  return (
    <Helmet>
      <title>{full}</title>
      <meta name="description" content={description} />
      <meta property="og:title" content={full} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={image} />
      <meta name="twitter:title" content={full} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
    </Helmet>
  );
};
